module.exports = __webpack_public_path__ + "static/media/more-options-question-pink.096b1712.svg";